<!--
 * @Author: c.k
 * @Date: 2022-07-25 10:39:30
 * @LastEditors: c.k
 * @LastEditTime: 2022-07-25 14:25:01
 * @Descripttion: 
-->
<template>
  <div class="logo_box">
    <div class="logo_img">
      <img src="../../assets/logo.png" alt="" />
    </div>
    <div class="logo_right">
      <div class="logo_right_one">
        <div>
          <img src="../../assets/kehu.png" alt="" />
        </div>
        <div class="logo_right_one_text">
          <p>联系电话</p>
          <p>95198</p>
        </div>
      </div>
      <div class="logo_right_two">
        <a
          class="logo_right_two_box"
          href="https://kjds.singlewindow.sc.cn:7002/login"
          target="_blank"
        >
          <span>立即申报</span>
          <img src="../../assets/right.png" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less">
.logo_box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 0;
}
.logo_img {
  img {
    width: 421px;
  }
}
.logo_right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  > div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.logo_right_one_text {
  padding-left: 10px;
  p:first-child {
    color: #596277;
    font-size: 16px;
  }
  p:last-child {
    font-size: 26px;
    color: #0b2154;
  }
}
.logo_right_two {
  padding-left: 43px;
  a{
    text-decoration: none;
  }
}
.logo_right_two_box {
  background: #bf1929;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 17px 38px;
  cursor: pointer;
  > span {
    font-size: 16px;
    display: block;
    color: #fff;
    padding-right: 8px;
  }
}
</style>
